export default function valid(el, binding)
{
	el.setCustomValidity(binding.value);
}
